import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { Button } from "../../../Common";
import { IAuditionQuestion } from "../../../../interfaces/IAuditionQuestion";

const QuestionsDisplaySection = (props: {
  t: any;
  auditionQuestions: IAuditionQuestion[];
  showAddEditQuestions: boolean;
  onShowAddEditQuestions: () => void;
  pastAudition: boolean;
}) => {
  const {
    t,
    auditionQuestions,
    onShowAddEditQuestions,
    pastAudition,
  } = props;

  const activeAuditionQuestions = auditionQuestions.filter(
    (x) => x.status === true
  );

  return (
    <StyledSection>
      <StyledDiv>
        <ContentTitle className="opaque">
          {t("Custom Questions")}
        </ContentTitle>
        <Button
          disabled={pastAudition}
          variant="secondary"
          onClick={onShowAddEditQuestions}
        >
          {t("Edit")}
        </Button>
      </StyledDiv>
      <StyledForm className="opaque">
        {activeAuditionQuestions.map((q, index) => (
          <div className="form-group row" key={index + 1}>
            <div className="col-12" style={{ marginTop: "15px" }}>
              <label>{q.question}</label>
              <input
                type="text"
                className="form-control"
                value={""}
                disabled={true}
              />
            </div>
          </div>
        ))}
      </StyledForm>
    </StyledSection>
  );
};

export default withI18n()(QuestionsDisplaySection);

const StyledSection = styled.section`
  margin: ${p => p.theme.spacing(4, 0, 0, 0)};

  & .opaque { opacity: 0.5 }
`;

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ContentTitle = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;
`;

const StyledForm = styled.form`
  margin: ${p => p.theme.spacing(2, 0, 0, 0)};
`;
